/**
 * Created by hao.cheng on 2017/4/13.
 */
import React, { Component } from 'react';
import { Menu, Icon, Layout, Badge, Popover,Modal,Form,Input } from 'antd';
import screenfull from 'screenfull';
import { gitOauthToken, gitOauthInfo } from '../axios';
import { queryString } from '../utils';
//import avater from '../style/imgs/b1.jpg';
import SiderCustom from './SiderCustom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {actions as userActions, reducer as user} from '@/reducers/userReducer'
import {actions as devActions, reducer as dev} from '@/reducers/devManagerReducer'
import avapng from "./pic/avatar_default.png"
import { USER_CURRENT_GET,USER_UPDATE } from '@/fetch/url'
import { get,post } from '@/fetch/fetch'
import { showMessage } from './util/NoticeMessage'

const {user_logout} = userActions
const {reset_dev_tree} = devActions
const { Header } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;

class HeaderCustom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: '',
            visible: false,
            formLayout: 'horizontal',
            phone:'',
            comment:'',
        };
        //this.handleSumbit = this.handleSumbit.bind(this);
    }
    componentDidMount() {
        const QueryString = queryString();
        // if (QueryString.hasOwnProperty('code')) {
        //     console.log(QueryString);
        //     const _user = JSON.parse(localStorage.getItem('user'));
        //     !_user && gitOauthToken(QueryString.code).then(res => {
        //         console.log(res);
        //         gitOauthInfo(res.access_token).then(info => {
        //             this.setState({
        //                 user: info
        //             });
        //             localStorage.setItem('user', JSON.stringify(info));
        //         });
        //     });
        //     _user && this.setState({
        //         user: _user
        //     });
        // }
        this.getCurUser();
        const _user = JSON.parse(localStorage.getItem('user')) || '测试';
        if (!_user && QueryString.hasOwnProperty('code')) {
            gitOauthToken(QueryString.code).then(res => {
                gitOauthInfo(res.access_token).then(info => {
                    this.setState({
                        user: info
                    });
                    localStorage.setItem('user', JSON.stringify(info));
                });
            });
        } else {
            this.setState({
                user: _user
            });
        }
    };
    screenFull = () => {
        if (screenfull.enabled) {
            screenfull.request();
        }

    };
    menuClick = e => {
        console.log(e);
        e.key === 'logout' && this.logout();
        e.key === 'modify' && this.showModal();
    };
    logout = () => {
        localStorage.removeItem('user');
        this.props.reset_dev_tree()
        this.props.user_logout(this.props.user.userInfo.id);
        //this.props.history.push('/login')
    };

    getCurUser = () => {
        let that = this

        get(USER_CURRENT_GET).then(function (result) {
            if(result.success) {
                that.setState({
                    phone: result.content.phone,
                    comment: result.content.comment,
                });
            } else {

            }
        }).catch(function(error){
            console.log(error);
        });
    }

    popoverHide = () => {
        this.setState({
            visible: false,
        });
    };

    hideModal = () => {
        let that = this
        that.setState({
            visible: false,
        });
    }

    showModal = () => {
        let that = this
        that.setState({
            visible: true,
        });
    }

    updateUser = () => {

        let that = this
        let oldpasswd = that.refs.oldpasswd.input.value;
        let passwd = that.refs.passwd.input.value;
        let apasswd = that.refs.confirmpasswd.input.value;

        if (oldpasswd === "") {
            showMessage("warning", "旧密码不能为空","");
            return ;
        }

        if (passwd === "") {
            showMessage("warning", "新密码不能为空","");
            return ;
        }

        if (passwd != apasswd) {
            showMessage("warning", "两次输入密码不一致","");
            return ;
        }

        let params = new Object();
        params.name = that.state.phone;
        params.phone = that.state.phone;
        params.comment = that.state.comment;

        params.password = passwd;
        params.oldPassword = oldpasswd


        post(USER_UPDATE, params).then(function (result) {
            if(result.success) {
                that.hideModal();
                showMessage("success", "更新成功","");
            } else {
                showMessage("error", result.message,"");
                return;
            }
        }).catch(function(error){
            showMessage("error", "服务器请求失败，请检查网络情况","");
            console.log(error);
        });

    }

    getUserRole =()=> {
        let value = '';
        if (this.props.user.userRole === 'ENTERPRISE') {
            value = "企业用户";
        } else if (this.props.user.userRole === 'AGENTS') {
            value = "代理商用户";
        } else if (this.props.user.userRole === 'PROJECT') {
            value = "项目用户";
        } else if (this.props.user.userRole === 'PLATFORM') {
            value = "平台用户";
        } else {
            value = "用户中心";
        }


        return value;
    }

    handleVisibleChange = (visible) => {
        this.setState({ visible });
    };
    render() {
        const { responsive, path } = this.props;
        let webAvater = ''
        if(this.props.user && this.props.user.userInfo.avatar != '') {
            webAvater = this.props.user.userInfo.avatar
        }


        const { formLayout } = this.state;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        const buttonItemLayout = formLayout === 'horizontal' ? {
            wrapperCol: { span: 14, offset: 4 },
        } : null;

        return (
            <div>
            <Header style={{ background: '#fff', padding: 0, height: 65 }} className="custom-theme" >
                {
                    responsive.data.isMobile ? (
                        <Popover content={<SiderCustom path={path} popoverHide={this.popoverHide} />} trigger="click" placement="bottomLeft" visible={this.state.visible} onVisibleChange={this.handleVisibleChange}>
                            <Icon type="bars" className="trigger custom-trigger" />
                        </Popover>
                    ) : (
                        <Icon
                            className="trigger custom-trigger"
                            type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={this.props.toggle}
                        />
                    )
                }
                <Menu
                    mode="horizontal"
                    style={{ lineHeight: '64px', float: 'right' }}
                    onClick={this.menuClick}
                >
                    <Menu.Item key="full" onClick={this.screenFull} >
                        <Icon type="arrows-alt" onClick={this.screenFull} />
                    </Menu.Item>

                    <SubMenu title={<span className="avatar"><img src={avapng} alt="头像" /><i className="on bottom b-white" /></span>}>
                        <MenuItemGroup title={this.getUserRole()}>
                            <Menu.Item key="setting:1">你好 - {this.props.user.userInfo.userName}</Menu.Item>
                            <Menu.Item key="modify"><span>修改密码</span></Menu.Item>
                            <Menu.Item key="logout"><span onClick={this.logout}>退出登录</span></Menu.Item>
                        </MenuItemGroup>
                    </SubMenu>
                </Menu>
                <style>{`
                    .ant-menu-submenu-horizontal > .ant-menu {
                        width: 120px;
                        left: -40px;
                    }
                `}</style>
            </Header>

                <Modal
                    title="用户密码修改"
                    visible={this.state.visible}
                    onOk={this.updateUser.bind(this)}
                    onCancel={this.hideModal}
                    destroyOnClose={true}
                    okText="修改"
                    cancelText="取消"
                >
                    <Form layout={formLayout}>
                        <FormItem
                            label="手机号"
                            {...formItemLayout}
                        >
                            <Input value={this.state.phone} disabled />
                        </FormItem>

                        <FormItem
                            label="旧密码"
                            {...formItemLayout}
                        >
                            <Input  type="password" ref="oldpasswd" placeholder="请输入用户密码" />
                        </FormItem>
                        <FormItem
                            label="新密码"
                            {...formItemLayout}
                        >
                            <Input  type="password" ref="passwd" placeholder="请输入用户密码" />
                        </FormItem>
                        <FormItem
                            label="重复新密码"
                            {...formItemLayout}
                        >
                            <Input  type="password" ref="confirmpasswd" placeholder="请再次输入用户密码" />
                        </FormItem>

                    </Form>

                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { responsive = {data: {}} } = state.http;
    const user = state.user;
    return {responsive,user};
};

const mapDispatchToProps = dispatch => ({
    user_logout:bindActionCreators(user_logout,dispatch),
    reset_dev_tree:bindActionCreators(reset_dev_tree,dispatch)
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(HeaderCustom));



// WEBPACK FOOTER //
// ./src/components/HeaderCustom.jsx